import React, { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useGetPatientQuery } from "@store/patientApi";
import Loader from "@components/Loader/Loader";
import OnboardingFamilyMemberForm from "@components/Onboarding/OnboardingFamilyInfoForm/OnboardingFamilyMemberForm";
import OnboardingFamilyInfoForm from "@components/Onboarding/OnboardingFamilyInfoForm/OnboardingFamilyInfoForm";
import OnboardingForm from "@components/Onboarding/OnboardingForm/OnboardingForm";
import { useTranslation } from "react-i18next";
import GroupIcon from "@mui/icons-material/Group";

const FamilyInfo: FC = () => {
  const patientId = useSelector(
    (state: RootState) => state.home.selectedPatientId,
  );
  const accountId = useSelector((state: RootState) => state.account.accountId);
  const navigate = useNavigate();
  const { data: patient, isLoading } = useGetPatientQuery(patientId!, {
    skip: !patientId,
  });
  const { t } = useTranslation();

  useEffect(() => {
    if (!accountId) {
      navigate("/onboarding");
    } else if (!patient && !isLoading) {
      navigate("/onboarding/profile");
    }
  }, [patient, navigate, accountId, isLoading]);

  return (
    <>
      {isLoading || !patient ? (
        <Loader />
      ) : (
        <OnboardingForm
          title={t("familyInfo.title")}
          subtitle={t("familyInfo.subtitle")}
          icon={<GroupIcon fontSize="small" />}
        >
          <Routes>
            <Route
              path=""
              element={<OnboardingFamilyInfoForm patient={patient} />}
            />

            <Route path="add" element={<OnboardingFamilyMemberForm />} />
            <Route
              path=":familyMemberId"
              element={<OnboardingFamilyMemberForm />}
            />
          </Routes>
        </OnboardingForm>
      )}
    </>
  );
};

export default FamilyInfo;
